import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconSettings = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "silver",
		d: "M12.953 8.653C12.98 8.44 13 8.227 13 8c0-.226-.02-.44-.047-.653l1.407-1.1c.127-.1.16-.28.08-.427l-1.333-2.307c-.08-.146-.26-.2-.407-.146l-1.66.667c-.347-.267-.72-.487-1.127-.654L9.66 1.614c-.02-.16-.16-.28-.327-.28H6.667c-.167 0-.307.12-.327.28L6.087 3.38c-.407.167-.78.393-1.127.654L3.3 3.367c-.153-.06-.327 0-.407.147L1.56 5.82c-.087.147-.047.327.08.427l1.407 1.1C3.02 7.56 3 7.78 3 8c0 .22.02.44.047.653l-1.407 1.1c-.127.1-.16.28-.08.427l1.333 2.307c.08.146.26.2.407.146l1.66-.666c.347.266.72.486 1.127.653l.253 1.767c.02.16.16.28.327.28h2.666c.167 0 .307-.12.327-.28l.253-1.767c.407-.166.78-.393 1.127-.653l1.66.666c.153.06.327 0 .407-.146l1.333-2.307c.08-.146.047-.326-.08-.426l-1.407-1.1zM8 10.333c-1.287 0-2.333-1.046-2.333-2.333 0-1.287 1.046-2.333 2.333-2.333 1.287 0 2.333 1.046 2.333 2.333 0 1.287-1.046 2.334-2.333 2.334z"
	})
});
export default SvgIconSettings;
